<template>
  <!-- Version: 1.2 -->
  <h2>1. Popis hry</h2>
  <p>
    Zápas o mistrovství světa IIHF Highlight Games je unikátní softwarová simulace náhodně vybraných sestřihů hokejových
    zápasů pro vytvoření herních příležitostí.
  </p>
  <h2>2. Popis a délka hry</h2>
  <p>
    Jedno kolo elektronické sázkové hry trvá v průměru 5 minut a skládá se z oznámení o rozehrávkách pro daný zápas,
    zobrazení a výsledky. Výběr nejvýznamnějších hokejových událostí je statisticky nezávislý, náhodný a nepředvídatelné
    a generované generátorem náhodných čísel
  </p>
  <h2>3. Sázkové trhy</h2>
  <h3>3.1 Přesný počet gólů (včetně prodloužení)</h3>
  <p>
    Význam sázky na přesný počet gólů spočívá v tom, že musí být vstřelen přesný počet gólů. vstřelených v jednom
    zápase. Tato varianta sázení tedy znamená, že máte předpovědět přesný počet gólů bez ohledu na konečný výsledek
    celého zápasu.
  </p>
  <h3>3.2 Přesné góly domácího týmu (včetně prodloužení)</h3>
  <p>Sázka na přesný počet gólů, které domácí tým vstřelí v zápase.</p>
  <h3>3.3 Přesné góly hostujícího týmu (včetně prodloužení)</h3>
  <p>Sázka na přesný počet gólů, které hostující tým vstřelí v zápase.</p>
  <h3>3.4 Oba týmy skórují (základní hrací doba)</h3>
  <p>
    Abyste vyhráli sázku BTTS, musí oba týmy vstřelit alespoň jeden gól, a to s výsledkem 1:1. a výše, vítězná sázka.
    využít takových událostí k získání ziskových kurzů, když sází pouze jeden ze dvou týmům se podařilo skórovat.
  </p>
  <h3>3.5 Správný výsledek (včetně prodloužení)</h3>
  <p>
    Sázka na správný výsledek je sázení na to, jaký si myslíte, že bude konečný výsledek hokejového zápasu. Zápas bude s
    maximálně 5 góly, existuje 18 možných výsledků.
  </p>
  <h3>3.6 Výsledek zápasu (1X2) (řádná hra)</h3>
  <p>Sázka na výhru domácího týmu (1), výhru hostujícího týmu (2) nebo remízu (X).</p>
  <h3>3.7 Výsledek zápasu (1,2) (včetně prodloužení)</h3>
  <p>Sázka na výhru domácího týmu (1), výhru hostujícího týmu (2).</p>
  <h3>3.8 Výsledek zápasu a více/méně než 3.5 gólu</h3>
  <p>(Regulační hrací doba) Sázka na výsledek zápasu a celkový počet gólů, který bude nižší nebo vyšší než 3,5 gólu.</p>
  <h3>3.9 Výsledek zápasu a více/méně než 3.5 gólů</h3>
  <p>(Včetně prodloužení) Sázka na výsledek zápasu a celkový počet gólů, který bude nižší nebo vyšší než 3,5 gólu.</p>
  <h3>3.10 Více/Méně než 2,5 gólu domácího nebo hostujícího týmu</h3>
  <p>(Včetně prodloužení) Sázka na to, že domácí tým nebo hostující tým vstřelí více nebo méně než 2,5 gólu.</p>
  <h3>3.11 Více než 2,5, 3,5, 4,5 Celkový počet gólů (včetně Prodloužení)</h3>
  <p>Sázka na to, že celkový počet vstřelených gólů obou týmů bude v prodloužení vyšší než 2,5, 3,5 nebo 4,5. zápas.</p>
  <h3>3.12 Sázkové řady 2-way (v základní hrací době)</h3>
  <p>
    Sázková řada s kurzy stanovenými tak, aby určila favorita nebo outsidera v zápase. Tato Handicap vytváří mezi oběma
    týmy handicapovou čáru „půl gólu“, kde jsou 2 možné výsledky.
  </p>
  <h3>3.13 Sázkové řady 3-way (v základní hrací době)</h3>
  <p>
    Sázková řada s kurzy stanovenými tak, aby určila favorita nebo outsidera v zápase. Tato Handicap vytváří
    handicapovou čáru „na celý gól“ mezi dvěma týmy, kde jsou 3 možné výsledky (tj. včetně remízy).
  </p>
  <h3>3.14 Sázky na třetiny s nejvyšším počtem vstřelených gólů (základní hrací doba)</h3>
  <p>
    Sázka na to, ve které třetině padne nejvíce gólů. Může se jednat o 1. třetinu, 2. třetinu, Třetí třetina, nebo
    remíza.
  </p>
  <h3>3.15 Tým, který vyhraje nejvíce třetin (základní hrací doba)</h3>
  <p>Sázka na to, který tým vyhraje nejvíce třetin. Může se jednat o domácí tým, hostující tým nebo Remíza.</p>
  <h3>3.16 Který tým skóruje jako první? (Včetně Prodloužení)</h3>
  <p>Sázka na to, který tým v zápase vstřelí první gól?</p>
</template>
